export default __webpack_public_path__ + "static/truck_b.0084839dc5f27acbd7abaf555e5322cb.svg";